module.exports = __webpack_public_path__ + "img/12ne.c88a451f.svg";